const ITEMS = [
  "Mobile Apps (iOS & Android)",
  "AI Engine Implementations",
  "Digital Subscription Infrastructure",
  "Principal: Justin Kingaby",
  "ABN: 13 907 721 664",
  "Serving Australia & Global Markets",
];

export const Marquee = () => {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <section
      aria-hidden="true"
      className="py-3 bg-emerald-900 text-emerald-100 overflow-hidden text-xs uppercase tracking-widest kaje-mono border-y border-emerald-800"
      data-testid="services-marquee"
    >
      <div className="kaje-mq-track flex items-center gap-8 font-semibold">
        {doubled.map((item, i) => (
          <span key={i}>&bull; {item}</span>
        ))}
      </div>
    </section>
  );
};
